import {
	Popover as PopoverMui,
	PopoverProps as PopoverPropsMui,
} from '@mui/material';
import * as React from 'react';
import styled from 'styled-components';
import { useTheme } from 'stylesHooks';

type PopoverProps = PopoverPropsMui;

const StyledPopover = styled(PopoverMui)``;

const Popover: React.FC<PopoverProps> = props => {
	const theme = useTheme();
	return (
		<StyledPopover
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			{...props}
			sx={{
				top: '-8px',
				'.MuiPaper-root': {
					padding: 0,
					gap: 0,
					'.MuiButtonBase-root + .MuiButtonBase-root': {
						borderTop: `1px solid ${theme.palette.grey4.main}`,
					},
				},
				...props.sx,
			}}
		/>
	);
};

export default Popover;
